import * as React from 'react';

import type {StackSpacing} from '../layout/stack/stack-legacy';
import {PopoverInfo} from '../popover-info/popover-info';
import type {PopoverInfoProps} from '../popover-info/popover-info';
import {SavedSettingToast} from '../saved-setting-toast/saved-setting-toast';
import type {SavedSettingToastState} from '../saved-setting-toast/saved-setting-toast';

import {UppercaseLabel} from './uppercase-label';

type Props = {
    label: string | React.ReactNode;
    labelButton?: React.ReactNode;
    labelPopoverProps?: PopoverInfoProps;
    sublabel?: string | React.ReactNode;
    isSublabelHorizontal?: boolean;
    content: string | React.ReactNode;
    spacing?: StackSpacing;
    isFullHeight?: boolean;
    state?: SavedSettingToastState;
};

export function LabelWithContent(props: Props) {
    return (
        <div className={props.isFullHeight ? 'flex flex-dir-col full-height' : 'flex flex-dir-col'}>
            <div
                style={props.spacing ? {marginBottom: `${props.spacing}px`} : undefined}
                className={props.isSublabelHorizontal ? 'flex flex-dir-row justify-sb' : ''}
            >
                <div className='flex align-center justify-sb'>
                    <SavedSettingToast state={props.state || 'initial'}>
                        {typeof props.label === 'string' ? (
                            <UppercaseLabel>{props.label}</UppercaseLabel>
                        ) : (
                            props.label
                        )}
                        {props.labelPopoverProps && <PopoverInfo {...props.labelPopoverProps} />}
                    </SavedSettingToast>
                    {props.labelButton}
                </div>
                {props.sublabel ? <div>{props.sublabel}</div> : undefined}
            </div>
            {props.content}
        </div>
    );
}
